import { PaginationValues } from "../types/General/PaginationValues";
import { Role } from "../types/Role/Role";
import api from "../utils/api";
import { ROLE_URL } from "../utils/endpoints";

export async function getRole(
  filterValues?: any,
  paginationValues?: PaginationValues,
) {
  try {
    const response = await api.get(ROLE_URL, {
      params: {
        ...filterValues,
        ...paginationValues,
      },
    });
    const data: Role[] = response.data.result.map((option: Role) => ({
      id: option.id,
      name: option.name,
      level: option.level,
      permissions: option.permissions,
    }));

    return { content: data, totalItems: response.data.totalItems };
  } catch (error) {
    throw error;
  }
}
